import React, { useState, useRef, useEffect } from "react";
import styles from "./styles.module.css";
import { EVENTS, INVOICE_ACTIONS } from "const";
import { eventsEmitter } from "utils/events";
import * as TerminalHelper from "helpers/TermialHelper";

import MoreIcon from "images/svg/more.svg";
import SaveInvoiceIcon from "images/svg/save-invoice.svg";
import WhatsAppIcon from "images/svg/whatsapp.svg";
import PaymentIcon from "images/svg/wallet-add.svg";
import KOTprintIcon from "images/svg/kot-print.svg";
import PrintIcon from "images/svg/printer.svg";

const CheckoutActionMenu = React.forwardRef(
  (
    {
      onDefaultActionClick,
      onPrintClick,
      onSaveInvoice,
      onSaveAndWhatsApp,
      onPrintAndWhatsApp,
      onPaymentQr,
      onKotAndPrint,
      disabled = false,
      isLoading = false,
      buttonLabel = "F4 Print",
      className = "",
    },
    ref,
  ) => {
    const [showMoreMenu, setShowMoreMenu] = useState(false);
    const dropdownRef = useRef(null);
    const isDisabled = disabled || isLoading;

    const terminalSettings = TerminalHelper.getTerminalSettings();
    const currentAction = terminalSettings?.defaultInvoiceAction || INVOICE_ACTIONS.PRINT;

    useEffect(() => {
      const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
          setShowMoreMenu(false);
        }
      };
      const unsubscribeFn = eventsEmitter.on(EVENTS.MOUSE_DOWN, handleClickOutside);
      return unsubscribeFn;
    }, []);

    const handleAction = (callback) => {
      if (isDisabled) return;
      setShowMoreMenu(false);
      if (callback) callback();
    };

    return (
      <div className={`${styles.actionBtnContainer} ${className}`}>
        <button
          ref={ref}
          className={styles.printBtn}
          onClick={() => handleAction(onDefaultActionClick)}
          disabled={isDisabled}
        >
          {buttonLabel}
        </button>
        <div className={styles.moreWrapper} ref={dropdownRef}>
          <div
            className={`${styles.moreIcon} ${isDisabled ? styles.disabled : ""}`}
            onClick={() => {
              if (isDisabled) return;
              setShowMoreMenu((prev) => !prev);
            }}
          >
            <img src={MoreIcon} alt="More Options" style={{ width: "22px" }} />
          </div>

          {showMoreMenu && (
            <div className={styles.moreMenu}>
              {onSaveInvoice && currentAction !== INVOICE_ACTIONS.SAVE && (
                <div className={styles.menuItem} onClick={() => handleAction(onSaveInvoice)}>
                  <img src={SaveInvoiceIcon} alt="Save" />
                  <h3>Save (F5)</h3>
                </div>
              )}
              {onKotAndPrint && currentAction !== INVOICE_ACTIONS.WITH_KOT && (
                <div className={styles.menuItem} onClick={() => handleAction(onKotAndPrint)}>
                  <img src={KOTprintIcon} alt="KOT & Print" />
                  <h3>KOT & Print (F6)</h3>
                </div>
              )}

              {onSaveAndWhatsApp && currentAction !== INVOICE_ACTIONS.SAVE_AND_WHATSAPP && (
                <div className={styles.menuItem} onClick={() => handleAction(onSaveAndWhatsApp)}>
                  <img src={WhatsAppIcon} alt="Save & WhatsApp" />
                  <h3>Save & WhatsApp (F7)</h3>
                </div>
              )}

              {onPrintClick && currentAction !== INVOICE_ACTIONS.PRINT && (
                <div className={styles.menuItem} onClick={() => handleAction(onPrintClick)}>
                  <img src={PrintIcon} alt="Print" />
                  <h3>Print (F8)</h3>
                </div>
              )}

              {onPrintAndWhatsApp && currentAction !== INVOICE_ACTIONS.PRINT_AND_WHATSAPP && (
                <div className={styles.menuItem} onClick={() => handleAction(onPrintAndWhatsApp)}>
                  <img src={WhatsAppIcon} alt="Print & WhatsApp" />
                  <h3>Print & WhatsApp</h3>
                </div>
              )}

              {onPaymentQr && currentAction !== INVOICE_ACTIONS.PAYMENT && (
                <div className={styles.menuItem} onClick={() => handleAction(onPaymentQr)}>
                  <img src={PaymentIcon} alt="Payment" />
                  <h3>Payment</h3>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  },
);

export default CheckoutActionMenu;
